import FormulateVueCustomCheckbox from './FormulateVueCustomCheckbox';

export default function FormulateVueCustomCheckboxPlugin(formulateInstance) {
  formulateInstance.extend({
    components: {
      FormulateVueCustomCheckbox,
    },
    library: {
      customCheckbox: {
        classification: 'box',
        component: 'FormulateVueCustomCheckbox',
        slotProps: {
          component: ['settings'],
        },
      },
    },
  });
}
